<template>
    <div class="fot-hd">
        <div style="border-bottom: 1rem solid #d7d7d7">
            <div class="footer">
                <div class="fot_pic">
                    <div class="douyin_box">
                        <!-- <a :href="msgs.douyinLink" target="_blank"> <img src="../../static/images/douyin1.png" alt="" /> </a -->
                        <a href="javascript:"> <img class="fotImg" src="../../static/images/douyin1.png" alt="" /> </a>
                        官方抖音
                        <img id="douyin" :src="msgs.douyinLink" alt="" />
                    </div>
                    <div class="weibo_box">
                        <a href="javascript:"> <img class="fotImg" src="../../static/images/web1.png" alt="" /> </a>
                        官方微博
                        <img id="weibo" :src="msgs.weiboLink" alt="" />
                    </div>
                    <div class="weixin_box">
                        <a href="javascript:"> <img class="fotImg" src="../../static/images/weixin1.png" alt="" /> </a>
                        官方微信
                        <img id="weixin" :src="msgs.wechatLink" alt="" />
                    </div>
                </div>
                <div style="width: 37%">
                    <div>
                        <p class="mb_new_p">地址：{{ msgs.address }}</p>
                        <p style="width: 309rem" class="mb_em">邮箱：{{ msgs.email }}</p>
                    </div>
                    <div class="mb_div">
                        <p class="mb_new_div_p">集团电话：{{ msgs.tel }}</p>
                        <p>合作热线：{{ msgs.hotLine }}</p>
                    </div>
                </div>
                <div class="youqing_box">
                    <div class="divflex2">
                        <p class="divflex2_p1">友情链接</p>
                        <p style="color: #1c76ce; width: 147rem; margin: 0">friendly link</p>
                    </div>
                    <div>
                        <div class="divflex3">
                            <el-select value="" placeholder="政府网站链接区">
                                <a target="_blank" :href="item.address" v-for="(item, index) in lianjie2" :key="index">
                                    <el-option value="value1" :label="item.name" style="height: 34px; line-height: 34px;"> </el-option>
                                </a>
                            </el-select>
                        </div>
                    </div>
                    <div>
                        <div class="divflex4">
                            <el-select value="" placeholder="行业网站链接区">
                                <a target="_blank" :href="item.address" v-for="(item, index) in lianjie" :key="index">
                                    <el-option value="value2" :label="item.name" style="height: 34px; line-height: 34px;"> </el-option>
                                </a>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div style="display: flex; width: 100%; align-items: center; justify-content: flex-end">
                <img src="../../static/images/fot_zmlogo.png" style="width: 30rem; height: 30rem" class="mb_fot_img" />
                <span style="font-size: 16rem" class="mb_new_sp">中明建投建设集团有限责任公司</span>
            </div>
            <div
                style="width: 46%; font-size: 16rem; margin-left: 40rem; display: flex; align_items: center"
                class="mb_new_sp">
                <!-- 网站备案： -->
                <a :href="msgs.internetRecordLink" target="_blank">{{ msgs.internetRecord }}</a>
            </div>
            <div style="width: 100%; font-size: 16rem; display: flex; align-items: center" class="mb_new_sp">
                <img src="@/assets/jinghui.png" style="width: 18rem; height: 18rem" class="mb_fot_img" />
                <!-- 网站备案： -->
                <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019102000389" target="_blank"
                    >陕公网备61019102000389号</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { getfriendship } from '@/api/api';
import { getmsg } from '@/api/api';

export default {
    data() {
        return {
            golaburl: 'http://39.101.74.19:8717/base-admin',
            value1: '政府网站链接区',
            value2: '行业网站链接区',
            label1: '政府网站链接区',
            label2: '行业网站链接区',
            lianjie: [],
            lianjie2: [],
            status: 2,
            status2: 1,
            msgs: [],
            options: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
                {
                    value: '选项2',
                    label: '双皮奶',
                },
                {
                    value: '选项3',
                    label: '蚵仔煎',
                },
                {
                    value: '选项4',
                    label: '龙须面',
                },
                {
                    value: '选项5',
                    label: '北京烤鸭',
                },
            ],
            value: '',
        };
    },

    mounted() {
        this.getfriendship();
        this.getfriendshiptwo();
        this.getmassage();
    },

    methods: {
        // 展示联系二维码
        showDouyinimg() {
            this.showDouyin = true;
            this.showWweibo = false;
            this.showWeixin = false;
        },
        // 展示联系二维码
        showWeiboimg() {
            this.showDouyin = false;
            this.showWweibo = true;
            this.showWeixin = false;
        },

        showWeixinimg() {
            this.showDouyin = false;
            this.showWweibo = false;
            this.showWeixin = true;
        },
        // goproduct(loc) {
        //     let toElement = document.getElementById(loc);
        //     toElement.scrollIntoView();
        //     this.$router.push('/product');
        //     // this.$router.go(0);
        // },
        // 锚点跳转
        // goproduct(path, id) {
        //     var path = path;
        //     var Id = id;
        //     localStorage.setItem('toId', Id);
        //     this.$router.push(path);
        // },
        // 友情链接
        async getfriendship() {
            const res = await getfriendship(this.status);
            if (res.code == 200) {
                this.lianjie = res.data;
                // //
            }
        },
        async getfriendshiptwo() {
            const res = await getfriendship(this.status2);
            if (res.code == 200) {
                this.lianjie2 = res.data;
                // //
            }
        },
        async getmassage() {
            const res = await getmsg();
            if (res.code == 200) {
                this.msgs = res.data[0];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1680px) {
    .fot_pic div {
        width: 65rem !important;
    }
}
@media screen and (max-width: 1440px) {
    .mb_new_p {
        width: 346rem !important;
    }
    .mb_new_div_p {
        width: 247rem !important;
    }
    .fot_pic div {
        width: 83rem !important;
    }
    // .divflex2 {
    //     padding-left: 0rem !important;
    // }
    .youqing_box {
        margin-left: 26rem !important;
    }
}
@media screen and (max-width: 1360px) {
    .mb_new_p {
        width: 373rem !important;
    }
    .mb_new_div_p {
        width: 247rem !important;
    }
    .fot_pic div {
        width: 83rem !important;
    }
    // .divflex2 {
    //     padding-left: 0rem !important;
    // }
    .youqing_box {
        margin-left: 57rem !important;
    }
}
@media screen and (max-width: 1280px) {
    .mb_new_p {
        width: 400rem !important;
    }
    .mb_new_div_p {
        width: 247rem !important;
    }
    .fot_pic div {
        width: 83rem !important;
    }
    // .divflex2 {
    //     padding-left: 0rem !important;
    // }
    .youqing_box {
        margin-left: 107rem !important;
    }
    .footer {
        width: 70% !important;
    }
    .divflex3 {
        margin-left: 19rem !important;
    }
}
@media screen and (max-width: 1152px) {
    .fotter {
        width: 75% !important;
    }
    .mb_new_p {
        width: 430rem !important;
    }
    .mb_new_div_p {
        width: 247rem !important;
    }
    .fot_pic div {
        width: 95rem !important;
    }
    // .divflex2 {
    //     padding-left: 0rem !important;
    // }
    .youqing_box {
        margin-left: 146rem !important;
    }
    .footer {
        width: 70% !important;
    }
    .divflex2 {
        margin-left: 10rem !important;
    }
    .mb_new_sp {
        width: 80% !important;
    }
    .boutique_box {
        width: 89% !important;
    }
}
@media screen and (max-width: 1024px) {
    .mb_new_p {
        width: 512rem !important;
    }
    .mb_em {
        width: 355rem !important;
    }
    .mb_new_div_p {
        width: 300rem !important;
    }
    .footer {
        width: 85% !important;
    }
    .bottom {
        width: 66% !important;
    }
}

.divflex2 {
    width: 17%;
    height: 40rem;
    border-left: 2rem solid #0e6eb8;
    padding-left: 10rem;
    font-size: 10rem;
}
.divflex2_p1 {
    color: #333333;
    font-size: 18rem;
    font-weight: Bold;
    width: 112rem;
    margin: 0;
}
.divflex3 {
    /*border:1rem solid #0E6EB8*/
    margin-right: 11rem;
    width: 166rem;
    height: 40rem;
    margin-left: 10rem;
    border-radius: 4rem;
}
.divflex4 {
    /*border:1rem solid #0E6EB8*/
    margin-right: 11rem;
    width: 166rem;
    height: 40rem;
}

// >>> .el-input__suffix {
//     right: -4rem;
//     top: 21rem;
//     transition: all 0.3s;
//     pointer-events: none;
// }
a {
    color: #656565;
    text-decoration: none;
}
a:hover {
    color: #656565 !important;
    text-decoration: none;
}
#douyin {
    width: 200rem;
    position: absolute;
    bottom: 57rem;
    left: 0rem;
    z-index: 200;
    display: none;
}
#weibo {
    width: 200rem;
    position: absolute;
    bottom: 57rem;
    left: 0rem;
    z-index: 200;
    display: none;
}
#weixin {
    width: 200rem;
    position: absolute;
    bottom: 57rem;
    left: 0rem;
    z-index: 200;
    display: none;
}
.douyin_box:hover #douyin {
    display: block;
}
.weibo_box:hover #weibo {
    display: block;
}
.weixin_box:hover #weixin {
    display: block;
}
.fot-hd {
    background-image: url('https://tp.hengzhi.shop/image/default/0F4F8A7534DB4390BDD51646DF91D484-6-2.png');
    width: 100%;
    margin-top: 20rem;
}

.footer {
    // width: 1320rem;
    width: 69%;
    height: 160rem;
    display: flex;
    align-items: center;
    // border-bottom: 1rem solid #d7d7d7;
    /* padding: 0rem 31rem; */
    box-sizing: border-box;
    margin: 0 auto;
    justify-content: space-around;

    > div:nth-child(1) {
        // width: 180rem;
        // width: 15%;
        // background-color: skyblue;
        // height: 66rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 20rem;
        color: rgba(101, 101, 101, 1);
        position: relative;
    }
    > div:nth-child(2) {
        // width: 546rem;
        // width: 42%;
        width: 50%;
        height: 62rem;
        // background-color: skyblue;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 50rem;
        color: #656565;
        font-size: 14rem;
    }
    > div:nth-child(3) {
        // width: 516rem;
        width: 39%;
        height: 40rem;
        // background-color: skyblue;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #656565;
        font-size: 14rem;
    }
    >>> .el-select > .el-input--suffix > .el-input__inner {
        padding-right: 30rem;
        margin-left: 20px;
        height: 40px;
    }
    >>> .el-select .el-input .el-select__caret {
        position: absolute;
    }
}
@media screen and (max-width: 1152px) {
    >>> .el-select > .el-input--suffix > .el-input__inner {
        margin-left: 20px;
    }
}
.fot_pic div {
    width: 54rem;
    // height: 73rem;
    text-align: center;
    display: flex;
    flex-direction: column;
}
.bottom {
    width: 52%;
    height: 60rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14rem;
    color: rgba(101, 101, 101, 1);
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue